<!-- Dashboard start -->
<!-- END: Left Aside -->

<ngx-spinner
  bdColor="rgba(75, 55, 100, 0.5)"
  size="large"
  color="#fff"
  type="line-scale-pulse-out">
    <span class="chevron left"></span>
    <span class="chevron right"></span>
</ngx-spinner>

<div class="m-grid__item m-grid__item--fluid m-wrapper" *ngIf="form">
  <!--MAIN-->
  <div class="m-content">
    <!--begin::Portlet-->
    <div class="m-portlet">
      <div class="m-portlet__head">
        <div class="m-portlet__head-caption">
          <div class="m-portlet__head-title">
            <h3 class="m-portlet__head-text" *ngIf="!merchantId">
              CHARITY DETAILS
            </h3>
            <h3 class="m-portlet__head-text" *ngIf="merchantId">
              EDIT CHARITY
            </h3>
          </div>
        </div>
      </div>

      <!--begin::Form-->
      <form
        [formGroup]="form"
        *ngIf="form"
        class="m-form m-form--fit m-form--label-align-right"
      >
        <div class="m-portlet__body">
          <div class="m-form__section m-form__section--first">

            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
                Charity Name:
              </label>
              <div class="col-lg-4">
                <input
                  formControlName="name"
                  type="text"
                  id="name"
                  class="form-control m-input"
                  placeholder=""
                />
                <app-validation-display
                  [control]="form.controls.name"
                  errorMessage="Merchant name is required"
                ></app-validation-display>
              </div>
            </div>

            <div class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label">
                  Email:
                </label>
                <div class="col-lg-4">
                  <input
                    formControlName="email"
                    type="text"
                    [ignoreWhiteSpace]
                    id="name"
                    class="form-control m-input"
                    placeholder=""
                  />
                  <p style="color:red; padding: 0; font-family: 'Open Sans', sans-serif; font-size: 12px; font-weight: 300;" *ngIf="form.controls.active.value == true">
                    Cannot edit email addresses of Stripe verified accounts
                  </p>
                  <app-validation-display
                    *ngIf="form.controls.email?.errors?.email === true"
                    [control]="form.controls.email"
                    errorMessage="Not a valid email address."
                  ></app-validation-display>
                  <app-validation-display
                    *ngIf="form.controls.email?.errors?.required === true"
                    [control]="form.controls.email"
                    errorMessage="Merchant email is required"
                  ></app-validation-display>
                </div>
            </div>

            <div class="form-group m-form__group row">
              <label class="col-lg-4 col-form-label">
                Home Page URL:
              </label>
              <div class="col-lg-4">
                <input
                  formControlName="homePageUrl"
                  type="text"
                  [ignoreWhiteSpace]
                  id="name"
                  class="form-control m-input"
                  placeholder=""
                />
                <app-validation-display
                  [control]="form.controls.homePageUrl"
                  errorMessage="Not a valid URL."
                ></app-validation-display>
              </div>
          </div>
          <div class="form-group m-form__group row">
            <label class="col-lg-4 col-form-label">
              Charity Description:
            </label>
            <div class="col-lg-4">
              <textarea
                formControlName="description"
                type="text"
                class="form-control m-input"
                placeholder=""
                rows="5"
              ></textarea>
              <app-validation-display
                [control]="form.controls.description"
                errorMessage="Description must be less than 300 characters."
              ></app-validation-display>
            </div>
        </div>
        <div class="form-group m-form__group row">
          <label class="col-lg-4 col-form-label">
            Charity Image:
          </label>
          <div class="col-lg-4">
            <input
              type="file"
              (change)="verifyImageDimensions($event.target.files[0])"
              class="venue-fileinput"
              accept="image/*"
            />
            <img 
              *ngIf="form.controls.imageUrl !== ''"
              alt="" [src]="form.controls.imageUrl.value" style="display: block;"/>
            <span
              onselectstart="return false"
              class="img-text"
              style="display: block;"
            >
              Click here to upload an image of the charity. Image must have a minimum width of 1380 px and a minimum height of 406px.
            </span>
            <app-validation-display
              *ngIf="form.controls.imageUrl?.errors?.incorrectDimensions === true"
              [control]="form.controls.imageUrl"
              errorMessage="Make sure the file is an image, has a height greater than or equal to 406px, and a width greater than or equal to 1380px."
            ></app-validation-display>
          </div>
      </div>

   

         
            <div *ngIf="false" class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label">
                Show Address Fields:
                </label>
                <div class="col-lg-6">
                <label class="switch">
                    <input
                    formControlName="showAddressFields"
                    type="checkbox"
                    />
                    <span class="slider round"></span>
                </label>
                </div>
            </div>

          <div *ngIf="form.controls.showAddressFields.value"> 

            <div class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label">
                    Address Line 1:
                </label>
                <div class="col-lg-4">
                  <input
                    formControlName="addressLine1"
                    type="text"
                    id="name"
                    class="form-control m-input"
                    placeholder=""
                  />
                </div>
            </div>

            <div class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label">
                    Address Line 2:
                </label>
                <div class="col-lg-4">
                  <input
                    formControlName="addressLine2"
                    type="text"
                    id="name"
                    class="form-control m-input"
                    placeholder=""
                  />
                </div>
            </div>

            <div class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label">
                    Building Name:
                </label>
                <div class="col-lg-4">
                  <input
                    formControlName="buildingName"
                    type="text"
                    id="name"
                    class="form-control m-input"
                    placeholder=""
                  />
                </div>
            </div>

            <div class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label">
                    City:
                </label>
                <div class="col-lg-4">
                  <input
                    formControlName="city"
                    type="text"
                    id="name"
                    class="form-control m-input"
                    placeholder=""
                  />
                </div>
            </div>

            <div class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label">
                    State or Province:
                </label>
                <div class="col-lg-4">
                  <input
                    formControlName="stateProvince"
                    type="text"
                    id="name"
                    class="form-control m-input"
                    placeholder=""
                  />
                </div>
            </div>

            <div class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label">
                    Country:
                </label>
                <div class="col-lg-4">
                  <input
                    formControlName="country"
                    type="text"
                    id="name"
                    class="form-control m-input"
                    placeholder=""
                  />
                </div>
            </div>

            <div class="form-group m-form__group row">
                <label class="col-lg-4 col-form-label">
                    Postal Code:
                </label>
                <div class="col-lg-4">
                  <input
                    formControlName="postalCode"
                    type="text"
                    id="name"
                    class="form-control m-input"
                    placeholder=""
                  />
                </div>
            </div>

          </div>

          </div>
        </div>
      </form>
    </div>
    <div class="form-group m-form__group row">
      <div class="col-lg-12">
        <button [debounceClick] [disabled]="loading" type="submit" (click)="save()" class="btn btn-primary">
          {{ merchantId ? "Update" : "Create" }}
        </button>
        <button style="margin-left: 15px;" type="submit" (click)="navigateUp()" class="btn btn-danger">
          Cancel
        </button>
        <div *ngIf="hasValidationErrors">
          <span style="color:red">Please complete the required fields</span>
        </div>
        
      </div>

    </div>
  </div>
</div>
